import React from 'react';
import { useAppContext } from '../../context/AppContext';
import FieldGroup from '../FieldGroup';
import SectionTitle from '../SectionTitle';

function Step3Integrations() {
  const { projectDraft, dispatch } = useAppContext();
  
  const handleRadioChange = (e) => {
    const { name, value } = e.target;
    dispatch({ type: 'UPDATE_PROJECT_DRAFT', payload: { [name]: value } });
  };
  
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    dispatch({ type: 'UPDATE_PROJECT_DRAFT', payload: { [name]: checked } });
  };
  
  return (
    <div className="space-y-6">
      <SectionTitle title="Integrations" subtitle="Connect third-party services to your application." />
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FieldGroup label="Code Storage">
          <input type="text" value="GitHub" readOnly className="form-input bg-gray-50" />
        </FieldGroup>
        
        <FieldGroup label="Hosting">
          <input type="text" value="Cloudflare Pages" readOnly className="form-input bg-gray-50" />
        </FieldGroup>
        
        <FieldGroup label="AI Provider">
          <input type="text" value="OpenAI" readOnly className="form-input bg-gray-50" />
        </FieldGroup>
        
        <FieldGroup label="File Storage">
          <input type="text" value="Dropbox" readOnly className="form-input bg-gray-50" />
        </FieldGroup>
      </div>
      
      <FieldGroup label="Database Provider">
        <div className="flex space-x-6">
          <label className="flex items-center">
            <input 
              type="radio" 
              name="database" 
              value="ncb" 
              checked={projectDraft.database === 'ncb'} 
              onChange={handleRadioChange}
              className="h-4 w-4 text-indigo-600 border-gray-300 focus:ring-indigo-500" 
            />
            <span className="ml-2 text-sm text-gray-700">NoCodeBackend (NCB)</span>
          </label>
          <label className="flex items-center">
            <input 
              type="radio" 
              name="database" 
              value="supabase" 
              checked={projectDraft.database === 'supabase'} 
              onChange={handleRadioChange}
              className="h-4 w-4 text-indigo-600 border-gray-300 focus:ring-indigo-500" 
            />
            <span className="ml-2 text-sm text-gray-700">Supabase</span>
          </label>
        </div>
      </FieldGroup>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <div className="flex items-center">
          <input 
            type="checkbox" 
            name="pwaEnabled" 
            id="pwaEnabled" 
            checked={projectDraft.pwaEnabled || false} 
            onChange={handleCheckboxChange} 
            className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500" 
          />
          <label htmlFor="pwaEnabled" className="ml-3 text-sm">
            <span className="font-medium text-gray-900">Enable PWA Features</span>
            <p className="text-gray-500">Progressive Web App capabilities for mobile-like experience</p>
          </label>
        </div>
      </div>
    </div>
  );
}

export default Step3Integrations;